import getToken from '../services/cognito';
import ABTesting from '../utils/ab-testing';
import { getCookie } from '../utils/common/common';

// This has multiple callers which creates a condition where multiple concurrent
// requests can be made to get a token. Multiple identities are then created
// which may have negative consequences.
let tokenRefreshPromise = null;

const request = async ({
  uri,
  options,
  retries = 0,
  host = process.env.BASE_API_URL,
  authToken = true
}) => {
  let token = localStorage.getItem('access_token');
  if (!token) {
    if (!tokenRefreshPromise) {
      tokenRefreshPromise = getToken().then(newToken => {
        localStorage.setItem('access_token', newToken);
        tokenRefreshPromise = null;
        return newToken;
      });
    }
    // Wait until the first lock is resolved.
    token = await tokenRefreshPromise;
  }

  const abTestingGroup = ABTesting.getABTestingGroup();
  const abPromoTestGroup = getCookie(process.env.PROMO_AB_COOKIE)?.value;

  const abTestingHeader = abTestingGroup
    ? { 'x-ab-testing': abTestingGroup }
    : {};

  const abPromoTestingHeader = abPromoTestGroup
    ? { 'x-promo-test': abPromoTestGroup }
    : {};

  const headers = {
    ...((authToken && host !== window.location.origin) &&
      { Authorization: `Bearer ${token}` }),
    ...abTestingHeader,
    ...abPromoTestingHeader,
  };

  const response = await fetch(`${host}/${uri}`, {
    ...options,
    headers: options.headers ? {
      ...options.headers,
      ...headers,
    } : headers,
  });

  if (response.ok) {
    // A 204 carries no body by definition, so there is nothing to parse.
    // Callers get null and decide what an absent resource means for them.
    if (response.status === 204) {
      return null;
    }
    return response.json();
  }
  if (response.status === 403) {
    if (retries > 0) {
      throw new Error('could not retrieve the token');
    }
    const newToken = await getToken();
    localStorage.setItem('access_token', newToken);
    return request({ uri, options, retries: retries + 1 });
  }
  const error = await response.json();

  const errorInstance = new Error(error?.errors?.[0]?.code);
  errorInstance.metadata = error?.errors?.[0]?.meta;
  errorInstance.apiErrors = error.errors;

  throw errorInstance;
};

export default request;
